import {
  MAP_BOUNDS,
  MAP_POLYLINES,
  MAP_HIDDEN_ROUTES,
  MAP_MARKERS_HIDDEN,
  MAP_UNSCHEDULED_MARKERS_HIDDEN,
  MAP_MARKERS_CLUSTERED,
  MAP_LAYERS_HIDDEN,
  MAP_TILES_DARK,
  MAP_HOVER_STOP,
  MAP_CURRENT_DRIVER,
  MAP_PINPOINT_DRIVER,
  SET_RENDERED_POLYLINES,
  MAP_SNAP_TO_ROAD_VISIBLE,
  SET_MAP_ZOOM,
  SET_REFIT_HASH,
  SET_MAP_CENTER,
  MAP_IS_DRIVER_LIVE_LOCATION_VISIBLE
} from "./types";
import * as polyline from "@mapbox/polyline";
import API from "../../utils/axios";

export function setMapBounds(obj) {
  return {
    type: MAP_BOUNDS,
    obj
  };
}

export const setMapCenter = centerCoords => ({
  type: SET_MAP_CENTER,
  payload: centerCoords
});

export function setMapZoom(num) {
  return {
    type: SET_MAP_ZOOM,
    payload: num
  };
}

export function setPolylines(obj) {
  return {
    type: MAP_POLYLINES,
    obj
  };
}

export function setMarkersHidden(val) {
  return {
    type: MAP_MARKERS_HIDDEN,
    val
  };
}

export function setUnscheduledMarkersHidden(val) {
  return {
    type: MAP_UNSCHEDULED_MARKERS_HIDDEN,
    val
  };
}

export function setIsDriverLiveLocationVisible(isDriverLiveLocationVisible) {
  return {
    type: MAP_IS_DRIVER_LIVE_LOCATION_VISIBLE,
    payload: isDriverLiveLocationVisible
  };
}

export function setMarkersClustered(val) {
  return {
    type: MAP_MARKERS_CLUSTERED,
    val
  };
}

export function setRefitHash(str) {
  return {
    type: SET_REFIT_HASH,
    str
  };
}

export function setSnapToRoadVisible(bool) {
  return {
    type: MAP_SNAP_TO_ROAD_VISIBLE,
    bool
  };
}

export function setLayersHidden(val) {
  return {
    type: MAP_LAYERS_HIDDEN,
    val
  };
}

export function setTilesDark(val) {
  return {
    type: MAP_TILES_DARK,
    val
  };
}

export function setCurrentDriver(val) {
  return {
    type: MAP_CURRENT_DRIVER,
    val
  };
}

export function setPinpointDriver(val) {
  return {
    type: MAP_PINPOINT_DRIVER,
    val
  };
}

export function setHoverStop(val) {
  return function (dispatch, getState) {
    if (val && val.stop.id !== getState().extendable.id) {
      dispatch({
        type: MAP_HOVER_STOP,
        val
      });
    } else {
      dispatch({
        type: MAP_HOVER_STOP,
        val: null
      });
    }
  };
}

export function toggleRoute(id) {
  return function (dispatch, getState) {
    let { hiddenRoutes } = getState().map;

    hiddenRoutes = hiddenRoutes.includes(id)
      ? hiddenRoutes.filter(el => el !== id)
      : [...hiddenRoutes, id];

    dispatch({
      type: MAP_HIDDEN_ROUTES,
      arr: hiddenRoutes
    });
  };
}

let currentRoutesToFetch = [];

// Checking routes and fetching updated OSRM routes polylines
export function fetchRoutes(routes) {
  return async function (dispatch, getState) {
    const vehicles = getState().project.vehicles;
    let promisesArr = [];
    const queryStrObj = { ...getState().map.renderedPolylines };
    routes.forEach((route, i) => {
      const endLocationDefined = route.end_location_defined;
      let queryStr = route.stops
        .reduce(
          (prev, { address, type }) =>
            type === "break"
              ? prev
              : endLocationDefined === false && type === "end"
              ? prev
              : prev + `;${address.lng},${address.lat}`,
          ""
        )
        .slice(1);
      if (
        queryStrObj[route.id] !== queryStr &&
        !currentRoutesToFetch.find(routeToFetch => routeToFetch.id === route.id)
      ) {
        queryStrObj[route.id] = queryStr;
        const profile = vehicles.find(
          vehicle => vehicle.id === route.vehicle_id?.split("_")[0]
        )?.type_id?.profile;
        currentRoutesToFetch.push({ id: route.id, profile });
        promisesArr.push(
          API.post("v1/osrmb?overview=full", {
            coordinates: queryStr,
            profile
          })
        );
      }
    });

    const polylines = { ...getState().map.polylines };
    try {
      await Promise.all(promisesArr).then(results => {
        results.forEach((res, i) => {
          if (res.data) {
            // 1. check vehicle profile
            // 2. choose corresponding decoder
            polylines[currentRoutesToFetch[i].id] = decodePolyline(
              res.data.routes[0].geometry,
              currentRoutesToFetch[i].profile
            );
          } else {
            polylines[currentRoutesToFetch[i].id] = [];
          }
          if (i === results.length - 1) currentRoutesToFetch = [];
        });
        dispatch({ type: SET_RENDERED_POLYLINES, obj: queryStrObj });
      });
    } catch (e) {
      console.log(e);
      currentRoutesToFetch = [];
    }

    dispatch(setPolylines(polylines));
  };
}

function decodePolyline(polylineString, vehicleType, precision) {
  if (vehicleType === "bicycle") {
    return decodeBicyclePolyline(polylineString, precision);
  }
  return polyline.decode(polylineString);
}

function decodeBicyclePolyline(str, precision) {
  var index = 0,
    lat = 0,
    lng = 0,
    coordinates = [],
    shift = 0,
    result = 0,
    byte = null,
    latitude_change,
    longitude_change,
    factor = Math.pow(10, precision || 6);

  // Coordinates have variable length when encoded, so just keep
  // track of whether we've hit the end of the string. In each
  // loop iteration, a single coordinate is decoded.
  while (index < str.length) {
    // Reset shift, result, and byte
    byte = null;
    shift = 0;
    result = 0;

    do {
      byte = str.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    latitude_change = result & 1 ? ~(result >> 1) : result >> 1;

    shift = result = 0;

    do {
      byte = str.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    longitude_change = result & 1 ? ~(result >> 1) : result >> 1;

    lat += latitude_change;
    lng += longitude_change;

    coordinates.push([lat / factor, lng / factor]);
  }

  return coordinates;
}
